import type { ReactElement } from 'react';
import cx from 'clsx';
import { useIntl } from 'react-intl';
import { Label as AriaLabel, type LabelProps as AriaLabelProps } from 'react-aria-components';
import styles from './label.module.css';

interface FieldLabelProps extends AriaLabelProps {
  isOptional?: boolean;
}

export function FieldLabel({
  className,
  children,
  isOptional = false,
  ...props
}: FieldLabelProps): ReactElement {
  const intl = useIntl();
  const optionalSuffix = `\u00a0${intl.formatMessage({ id: 'form-elements-optional' })}`;
  // Keep backend-provided suffixes intact until all clients derive optional labels from the schema.
  const hasOptionalSuffix =
    typeof children === 'string' &&
    children.trimEnd().toLowerCase().endsWith(optionalSuffix.trim().toLowerCase());
  return (
    <AriaLabel className={cx(className, 'body-standard', styles.label)} {...props}>
      {children}
      {isOptional && !hasOptionalSuffix ? optionalSuffix : null}
    </AriaLabel>
  );
}
